<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="item.id"
      :class="{
        'border-b': addText || (index < (items.length - 1))
      }"
      class="border-shadow-color"
      @click="$emit('input', item)"
    >
      <slot
        :item="item"
        :active="value == item"
      />
    </div>
    <AddLine
      v-if="addText"
      @click.native="onAdd"
    >
      {{ addText }}
    </AddLine>
  </div>
</template>

<script>
import BaseAddLine from './BaseAddLine.vue';

export default {
  name: 'BaseRadioButtons',
  components: {
    BaseAddLine,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    addText: {
      type: String,
      default: null,
    },
    onAdd: {
      type: Function,
      default: () => null,
    },
    value: {
      type: [Object, String, Boolean, Number],
      default: null,
    },
  },
};
</script>

<style lang="css" scoped>
.custom-height {
  height: 21px;
  width: 18px;
}
</style>
